<template>
  <div class="page-wrapper basic-rules" >
    <Form :model="savaData" :rules="formRules" ref="rulusForm" >
      <Select v-model="savaData.projectFid" class="item-width" @on-change="changeProject">
        <Option v-for="item in projectList" :value="item.value" :key="item.value">{{item.text}}</Option>
      </Select>
    <div class="rules  mt-36">
      <div class="rules-item">
        付款方式折扣
      </div>
      <div class="rules-detail">
        <Row :gutter="16">
          <Col span="6">
            <span class="label">月付：</span>
            <FormItem label="" prop="conCycleDisCountMonth" class="w-80">
             <Input v-model="savaData.conCycleDisCountMonth" size="small" :disabled="isRead">
              <span slot="append">%</span>
             </Input>
            </FormItem>
          </Col>
          <Col span="6">
            <span class="label">季付：</span>
            <FormItem label="" prop="conCycleDisCountSeason"class="w-80" >
             <Input v-model="savaData.conCycleDisCountSeason" size="small" :disabled="isRead">
              <span slot="append">%</span>
             </Input>
            </FormItem>
          </Col>
          <Col span="6">
            <span class="label">半年付：</span>
            <FormItem label="" prop="conCycleDisCountHalfYear"class="w-80" >
             <Input v-model="savaData.conCycleDisCountHalfYear" size="small" :disabled="isRead">
              <span slot="append">%</span>
             </Input>
            </FormItem>
          </Col>
          <Col span="6">
            <span class="label">年付：</span>
            <FormItem label="" prop="conCycleDisCountYear"class="w-80" >
             <Input v-model="savaData.conCycleDisCountYear" size="small" :disabled="isRead">
              <span slot="append">%</span>
             </Input>
            </FormItem>
          </Col>
        </Row>
        <div class="flex">
            <span class="label">一次性付清：</span>
            <div class="flex-item">
              <WaveRentTermMonth :max="12" :disable="isRead" :waveData="item" v-for="(item,i) in list" :key="`${item.start}-${item.waveValue}`"  :basic="false" :i="i" :start="item.start" @add-form="addForm" :ref="`form${i}`"></WaveRentTermMonth>
            </div>
          </Col>
        </div>
        <p>注：一次性付清的租期区间默认都为闭合区间，例：【0 - 3】；【4 - 6】；【7 - 12】</p>
      </div>
    </div>
    <div class="rules">
      <div class="rules-item">
        是否开启企悦会权益
      </div>
      <div class="rules-detail">
        <Row :gutter="16">
          <Col span="8">
            <!--
            <FormItem label="" prop="qiyuehuiDiscount" class="w-80">
             <Input v-model="savaData.qiyuehuiDiscount" size="small" :disabled="isRead">
              <span slot="append">%</span>
             </Input>
            </FormItem>
            -->
            <FormItem label="" prop="isQiyehui" class="w-80">
              <i-switch  v-model="isQiyehui"  @on-change="changeSwitch" :disabled="isRead">
                <span slot="open" >开</span>
                <span slot="close" >关</span>
              </i-switch>
            </FormItem>
          </Col>
        </Row>
      </div>
    </div>
    <div class="rules">
      <div class="rules-item">
        是否开启自如会员权益
      </div>
      <div class="rules-detail">
        <Row :gutter="16">
          <Col span="8">
            <FormItem label="" prop="isOpenRegularMember" class="w-80">
              <i-switch  v-model="isOpenRegularMember"  @on-change="changeSwitch" :disabled="isRead">
                <span slot="open" >开</span>
                <span slot="close" >关</span>
              </i-switch>
            </FormItem>
          </Col>
        </Row>
      </div>
    </div>
    <div class="rules">
      <div class="rules-item">
        提前续约折扣
      </div>
      <div class="rules-detail">
        <div  class="flex">
          <span class="label">提前</span>
          <div class="flex-item">
            <ahead-renew-discount
              v-for="(item,i) in renewDiscountList"
              :waveData="item"
              :disable="isRead"
              :len="aheadRenewDiscountLen" :key="`${i}-${item.waveValue}`" :i="i"
              :renewDay="renewDay"
              :start="item.start"
              @change-end="changeRenewDiscountEnd"
              @remove-form="removeRenewDiscount"
              :ref="`aheadRenewForm${i}`">
            </ahead-renew-discount>
            <a v-if="!isRead && aheadRenewDiscountStart!==renewDay+1" href="javascript:;" @click="addAheadRenewDiscount" >添加</a>
          </div>
        </div>
      </div>
    </div>
    <div class="rules">
      <div class="rules-item">
        老客户折扣
      </div>
      <div class="rules-detail">
        <Row :gutter="16">
          <Col span="8">
            <span>连续居住满1年:</span>
            <FormItem label="" prop="oldDiscountOneYear" class="w-80">
              <Input v-model="savaData.oldDiscountOneYear" size="small" :disabled="isRead">
                <span slot="append">%</span>
              </Input>
            </FormItem>
          </Col>
          <Col span="8">
            <span>连续居住满2年:</span>
            <FormItem label="" prop="oldDiscountTwoYear" class="w-80">
              <Input v-model="savaData.oldDiscountTwoYear" size="small" :disabled="isRead">
                <span slot="append">%</span>
              </Input>
            </FormItem>
          </Col>
          <Col span="8">
            <span>连续居住满3年:</span>
            <FormItem label="" prop="oldDiscountThreeYear" class="w-80">
              <Input v-model="savaData.oldDiscountThreeYear" size="small" :disabled="isRead">
                <span slot="append">%</span>
              </Input>
            </FormItem>
          </Col>
        </Row>
      </div>
    </div>
    <div class="text-align-c mt36" v-if="!isRead">
      <Button class="mr20" type="primary" @click="save" :loading="loading">
          <span>保存</span>

        </Button>
      <!-- <Button class="mr20" type="primary" size="large" @click="save" :loading="loading">
        <span v-if="!loading">保存</span>
        <span v-else>保存中...</span>
      </Button> -->
      <FormItem label="" prop="isSynBoolean" class="check-box">
        <Checkbox  v-model="savaData.isSynBoolean">同步到权限内的所有项目</Checkbox>
      </FormItem>
    </div>
    </Form>
    <Button  v-if="!isRead" class="edit" type="primary" @click="cancleEdit">取消</Button>
    <Button v-if="isRead" class="edit" type="primary" @click="edit" v-p="{api:'serviceFeeDiscountRule/saveServiceFeeDiscountRule'}">编辑</Button>
  </div>
</template>

<script>
import { getProjects, getServiceFeeDiscountRule, saveServiceFeeDiscountRule } from 'api/managementCenter'
import  WaveRentTermMonth from './../components/WaveRentTermMonth'
import  AheadRenewDiscount from './components/AheadRenewDiscount'


export default {
  name: 'servicechargerules',
  created(){
    this.initData()
  },
  components:{
    WaveRentTermMonth,
    AheadRenewDiscount
  },
  data() {

    const validateNumber = (require,value,callback) => {
      let pattern = /^[1-9]\d*$/
      if(pattern.test(value) && +value <= 100){
          callback()
      }else{
        callback(new Error(' '))
      }
    }
    return {
      isQiyehui:'',
      isOpenRegularMember:'',
      loading: false,
      isRead:true,
      list:[{
        start:0,
        end:12,
        waveValue:''
      }],
      renewDay:0,
      aheadRenewDiscountStart:0,
      renewDiscountList:[{
        start:'',
        end:'',
        waveValue:''
      }],
      // listIndex:0,
      savaData:{
        aheadRenewDiscount: [],//提前续约折扣
        conCycleDisCountHalfYear: '',
        conCycleDisCountMonth: '',
        conCycleDisCountOnce: [],
        conCycleDisCountSeason: '',
        conCycleDisCountYear: '',
        isSynBoolean:false,
        isSyn: 0,
        oldDiscountOneYear: '',
        oldDiscountThreeYear: '',
        oldDiscountTwoYear: '',
        projectFid: '',
        qiyuehuiDiscount: '',
        isQiyehui:'',
        isOpenRegularMember:'',
      },
      formRules:{
        conCycleDisCountMonth:[{required: true, type:'number', validator:validateNumber,trigger:'blur'}],
        conCycleDisCountSeason:[{required: true, type:'number', validator:validateNumber,trigger:'blur'}],
        conCycleDisCountHalfYear:[{required: true, type:'number', validator:validateNumber,trigger:'blur'}],
        conCycleDisCountYear:[{required: true, type:'number', validator:validateNumber,trigger:'blur'}],
        qiyuehuiDiscount:[{required: true, type:'number', validator:validateNumber,trigger:'blur'}],
        oldDiscountOneYear:[{required: true, type:'number', validator:validateNumber,trigger:'blur'}],
        oldDiscountThreeYear:[{required: true, type:'number', validator:validateNumber,trigger:'blur'}],
        oldDiscountTwoYear:[{required: true, type:'number', validator:validateNumber,trigger:'blur'}]
      },
      projectList:[]
    }
  },
  computed:{
    aheadRenewDiscountLen(){
      return this.renewDiscountList.length
    }
  },
  methods:{
    initData(){
      getProjects().then( res => {
        this.projectList = res.data ? res.data : []
        if(this.projectList.length>0) {
          this.savaData.projectFid = this.projectList[0].value
          // this.savaData.projectFid = '16'
          // this.getRules(this.savaData.projectFid)
        }
      })
    },
    clearData(){
      // savaData
       this.$refs['rulusForm'].resetFields();
      for(let key in this.savaData){
        switch(key){
          case 'projectFid':
            break;
          case 'aheadRenewDiscount':
            this.savaData[key].length = 0
            break;
          case 'conCycleDisCountOnce':
            this.savaData[key].length = 0
            break;
          case 'isSyn':
            this.savaData[key] = 0;
            break;
          case 'isSynBoolean':
            this.savaData[key] = false;
            break;
          default:
            this.savaData[key] = '';
        }
      }
      this.isRead = true
      this.list = [{
        start:0,
        end:12,
        waveValue:''
      }]
      this.renewDiscountList = [{
        start:'',
        end:'',
        waveValue:''
      }]
    },
    cancleEdit(){
      this.clearData()
      this.getRules(this.savaData.projectFid)
      this.isRead = true
    },
    edit(){
      this.isRead = false
    },
    addAheadRenewDiscount(){
      // let index = this.renewDiscountList[this.aheadRenewDiscountLen-1].index
      this.renewDiscountList.push({
        // index:index+1,
        start:this.aheadRenewDiscountStart,
        end:'',
        waveValue:''
      })
    },
    changeSwitch(val){
      console.log(this)
         // this.$Message.error(val.value)
    },
    changeProject(val){
      this.clearData()
      this.getRules(val)
    },
    changeRenewDiscountEnd(data){
      if(data.preEnd === this.renewDay){
        this.aheadRenewDiscountStart = +data.preEnd+1
      }else{
        this.aheadRenewDiscountStart = +data.preEnd+1
        this.renewDiscountList.length = data.i+1
      }
    },
    getRules(val){
      if(!val){
        return
      }
      getServiceFeeDiscountRule(val).then(res => {
            this.renewDay = res.data.renewDay
            if(res.data.serviceFeeDiscountRuleDto){
              this.savaData = res.data.serviceFeeDiscountRuleDto
              this.isQiyehui=this.savaData.isQiyehui===1?true:false
              this.isOpenRegularMember=this.savaData.isOpenRegularMember===1?true:false
              // this.savaData.isSynBoolean = res.data.serviceFeeDiscountRuleDto.isSyn ? true : false
              if( res.data.serviceFeeDiscountRuleDto.conCycleDisCountOnce.length > 0 ) {
                this.list = res.data.serviceFeeDiscountRuleDto.conCycleDisCountOnce
              }
              if(res.data.serviceFeeDiscountRuleDto.aheadRenewDiscount.length > 0){
                this.renewDiscountList = res.data.serviceFeeDiscountRuleDto.aheadRenewDiscount
                let lastIndex = this.renewDiscountList.length-1
                this.aheadRenewDiscountStart = this.renewDiscountList[lastIndex].end +1
              }
            }
          })
    },
    removeRenewDiscount(start){
     // 删掉最后一个
     this.aheadRenewDiscountStart = start
     this.renewDiscountList.splice(-1,1)

    },
    addForm(data){
      let start = data.preEnd + 1
      this.listIndex = data.i + 1
      this.list.splice(this.listIndex)
      if(start == 13) return
      this.list.push({
        start: start,
        end:12,
        waveValue:''
      })
    },
    changeLoading() {
      this.loading = false;
      this.$nextTick(() => {
        this.loading = true;
      });
    },
    validateWaveRentTermMonth() {
      let waveRentTermMonthList = []
      let result = this.list.every( (item,i) => {
        waveRentTermMonthList.push(this.$refs[`form${i}`][0].formValidate())
        return this.$refs[`form${i}`][0].formValidate()
      })
      if(result) {

        return waveRentTermMonthList
      }else{
        return false
      }
    },
    validateAheadRenewForm(){
      let AheadRenewDiscount= []
      let result = this.renewDiscountList.every( (item,i) => {
        AheadRenewDiscount.push(this.$refs[`aheadRenewForm${i}`][0].formValidate())
        return this.$refs[`aheadRenewForm${i}`][0].formValidate()
      })

      if(result) {

        return AheadRenewDiscount
      }else{
        return false
      }
    },
    save(){
      this.$refs[`rulusForm`].validate(bool => {
        if(bool){

          let result = this.validateWaveRentTermMonth()
          let aheadRenewDiscountResult = this.validateAheadRenewForm()
          // 企业会按钮重新赋值
          this.savaData.isQiyehui = this.isQiyehui == true? 1 : 0;
          this.savaData.isOpenRegularMember = this.isOpenRegularMember == true? 1 : 0;
          if(result && aheadRenewDiscountResult) {
            this.savaData.conCycleDisCountOnce = result
            this.savaData.aheadRenewDiscount = aheadRenewDiscountResult
            if(this.savaData.isSynBoolean){
              this.savaData.isSyn = 1
            } else {
              this.savaData.isSyn = 0
            }
            this.loading = true
            saveServiceFeeDiscountRule(this.savaData).then( res => {
              this.isRead = true
              this.$Message.success('保存成功');
              this.loading = false
            }).catch( res => {
              this.loading = false
            })
          } else {
            return
          }
        } else {
          return
        }
      })
    }
  }
}
</script>

<style scoped>
.ivu-form-item {
    display: inline-block;
    width: 60px;
  }
.rules {
  display: flex;
  margin-top: 16px;

}
.mt-36{
  margin-top:36px;
}
.rules-item {
  width: 120px;
  line-height: 26px;
  font-weight: 600;
}
.rules-detail {
  flex:1;
}
.rules-detail span {
  display: inline-block;
  line-height: 26px;
}
.ivu-input-group-append span {
  line-height: 1;
}

.label {
  padding-right:10px;
}
.dash {
  display: inline-block;
  padding-left: 4px;
  padding-right: 4px;
  text-align: center;
  }
  .dash span {
    display: inline-block;
    width: 8px;
    height: 2px;
    background: #dddee1;
    vertical-align: middle;
  }
  .w-80 {
    width: 80px;
  }

  .error-color{
    position: absolute;
    bottom: 0;
    display: none;
  }
  .block {
    display: block;
  }
  .ivu-checkbox-wrapper {
    margin-right: 24px;
  }
  .flex {
    display: flex;

  }
  .flex-item {
    flex: 1
  }
  p {
    color:#CFA868;
    margin-bottom: 24px;
  }
  a{
    color: #CFA868;
  }
  .edit {
    position:absolute;
    top: 60px;
    right: 24px;
  }
  .check-box {
    width:auto;
  }

</style>

